module.exports = __webpack_public_path__ + "sports-48-x-48.b0572a165605dc04c92c.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/sports/webfont/sports-48-x-48.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/sports/webfont/sports-48-x-48.woff
// module chunks = styles